import { createAction, props } from '@ngrx/store';

import { SortDirection } from '../constants';

export const setHomeFilterString = createAction(
  '[Home] Set Home Filter String',
  props<{ filterString: string }>(),
);

export const setHomeSortingField = createAction(
  '[Home] Set Home Sorting Field',
  props<{ sortingField: string }>(),
);

export const setHomeSortingDirection = createAction(
  '[Home] Set Home Sorting Direction',
  props<{ sortingDirection: SortDirection }>(),
);

export const setHomeObjectsLifeCycle = createAction(
  '[Home] Set Home Objects Lifecycle',
  props<{ homeObjectsLifeCycle: number }>(),
);
